import * as React from 'react';

var useRadioGroup = _ref => {
  var {
    value,
    onChange
  } = _ref;
  var [selectedValue, setSelectedValue] = React.useState(value);

  var handleOnChange = event => {
    var element = event.target;
    var value = element.value;
    onChange === null || onChange === void 0 ? void 0 : onChange(value);
    setSelectedValue(value);
  };

  return {
    selectedValue,
    handleOnChange
  };
};

export { useRadioGroup };
//# sourceMappingURL=useRadioGroup.js.map